import { render, staticRenderFns } from "./ProviderMonthlyRevenueWithProjection.vue?vue&type=template&id=3267ea6e"
import script from "./ProviderMonthlyRevenueWithProjection.vue?vue&type=script&lang=js"
export * from "./ProviderMonthlyRevenueWithProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports